import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import {
  GetPendingPaymentsResponse,
  Value,
} from '@/types/getPendingPaymentsType';
import { STATUSES } from '@/pages/PendingPayments/components/PendingPaymentsTable/columns';

type PendingPaymentsType = {
  status: string;
};

export const getPendingPayments = async (
  query: PendingPaymentsType
): Promise<Value[]> => {
  try {
    const res = await apiClient.post<GetPendingPaymentsResponse>(
      Endpoints.PendingPayments,
      {
        estado: query.status,
      }
    );

    const dataParsed = (res?.data?.value || []).map((item) => {
      const { listaDocumentosSeleccionados } = item;
      const total = listaDocumentosSeleccionados.reduce(
        (acum, { impMovMo }) => acum + (impMovMo || 0),
        0
      );
      const status = STATUSES[item.estado] || item.estado;

      const body = {
        ...item,
        totalAmount: total,
        estadoParseado: status,
      };

      return body;
    });

    return dataParsed;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
